import React, { createContext, useContext, useState } from 'react';

// Criação do contexto
const FiltroContext = createContext();

// Provider que compartilha os estados globais
export const FiltroProvider = ({ children }) => {
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [nomeBuscaProduto, setNomeBuscaProduto] = useState("");
  const [categoriaAtiva, setCategoriaAtiva] = useState("Todos");
  const [nomeCategoriaAtiva, setNomeCategoriaAtiva] = useState("Todos");
  const [itensPorPagina] = useState(10);

  return (
    <FiltroContext.Provider
      value={{
        paginaAtual,
        setPaginaAtual,
        nomeBuscaProduto,
        setNomeBuscaProduto,
        categoriaAtiva,
        setCategoriaAtiva,
        nomeCategoriaAtiva,
        setNomeCategoriaAtiva,
        itensPorPagina
      }}
    >
      {children}
    </FiltroContext.Provider>
  );
};

// Hook para usar o contexto de forma prática
export const useFiltro = () => useContext(FiltroContext);
